import { zonedDayStart as e, zonedDayString as t } from "../../utils/dates.js";
//#region lib/components/DatePicker/dateValue.ts
var n = 1e10;
function r(t, n) {
	if (n) return /* @__PURE__ */ new Date(e(t, n) * 1e3);
	let r = new Date(t);
	return r.setHours(0, 0, 0, 0), r;
}
function i(e, n) {
	if (n) return t(e, n);
	let r = e.getFullYear(), i = String(e.getMonth() + 1).padStart(2, "0"), a = String(e.getDate()).padStart(2, "0");
	return `${String(r)}-${i}-${a}`;
}
function a(t, i, a) {
	if (t !== void 0 && t !== "") {
		if (i === "date" && t instanceof Date) return Number.isNaN(t.getTime()) ? void 0 : r(t, a);
		if (i === "unix") {
			if (typeof t == "number") {
				let e = /* @__PURE__ */ new Date(t * 1e3);
				return Number.isNaN(e.getTime()) ? void 0 : r(e, a);
			}
			if (typeof t == "string" && t !== "") {
				let e = Number(t);
				if (!Number.isNaN(e)) {
					let t = /* @__PURE__ */ new Date(e * 1e3);
					return Number.isNaN(t.getTime()) ? void 0 : r(t, a);
				}
			}
		}
		if (typeof t == "string") {
			if (a && t.length === 10) {
				let [n, r, i] = t.split("-").map(Number);
				if (n && r && i) return /* @__PURE__ */ new Date(e(t, a) * 1e3);
			}
			let n = t.length === 10 ? /* @__PURE__ */ new Date(`${t}T00:00:00`) : new Date(t);
			return Number.isNaN(n.getTime()) ? void 0 : r(n, a);
		}
		if (typeof t == "number") {
			let e = t < n ? t * 1e3 : t, i = new Date(e);
			return Number.isNaN(i.getTime()) ? void 0 : r(i, a);
		}
	}
}
function o(e, t, n) {
	if (!e || Number.isNaN(e.getTime())) return t === "unix" || t === "date" ? void 0 : "";
	let a = r(e, n);
	return t === "date" ? a : t === "unix" ? Math.floor(a.getTime() / 1e3) : i(a, n);
}
function s(e, t, n) {
	if (e === void 0 || e === "") return "";
	if (t === "unix") {
		if (typeof e == "number") return String(e);
		if (typeof e == "string") return e;
		if (e instanceof Date) {
			let t = o(e, "unix", n);
			return t === void 0 ? "" : String(t);
		}
	}
	return t === "date" && e instanceof Date ? i(r(e, n), n) : typeof e == "string" ? e : typeof e == "number" ? String(e) : e instanceof Date ? i(r(e, n), n) : "";
}
//#endregion
export { o as fromDate, s as serializeFieldValue, r as startOfDay, a as toDate, i as toIsoDateString };
